import { useRequest } from '@mgm/common/lib';
import { TAxiosError } from '@mgm/common/types';
import { CONTROLLERS } from '../utils/enums';
import { TSetAvatarReq } from '../types/requests';
import { BASE_URL } from '../../config';
import { getIdToken } from '../utils/helpers';

export function StorageController() {
  const controllerName = CONTROLLERS.STORAGE;

  const {
    axiosRequest,
    initRequestOptions,
  } = useRequest(BASE_URL);

  const setAvatarFile = <T>(data: TSetAvatarReq): Promise<T | { success: boolean; error: TAxiosError }> => {
    const options = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/set_avatar`, options);
  };

  return {
    setAvatarFile,
  };
}
